import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F910 {
  f910_01: string;        // 員工代號 (PK)
  f910_02: string | null; // 出勤日期 (PK)
  f910_11: string;        // 出勤狀態碼 (N/H/M/W)
  f910_13: string;        // 簽到密碼
  f910_14: string;        // 出勤備註說明
  f910_15: string;        // 上班組別代號
  f910_16: string;        // 輪休組別代號
  f910_17: string;        // 請假單號
  f910_19: string;        // 出差單號
  f910_20: string;        // 調班單號
  f910_21: string;        // 刷卡上班時間
  f910_22: string;        // 刷卡下班時間
  f910_23: string;        // 加班刷卡開始時間
  f910_24: string;        // 加班刷卡結束時間
  f910_29: number;        // 遲到分鐘數
  f910_30: number;        // 早退分鐘數
  f910_31: string;        // 部門代號
  f910_32: string;        // 應上班時間 (唯讀)
  f910_33: string;        // 應下班時間 (唯讀)
  f910_91: string;        // 建立者 User ID
  f910_92: string | null; // 建立日期
  f910_93: string;        // 最後修改者
}

export interface CreateRequest {
  f910_01: string; // 員工代號
  f910_02: string; // 出勤日期 (YYYY-MM-DD)
  f910_11: string; // 出勤狀態碼
  f910_13: string; // 簽到密碼
  f910_14: string; // 出勤備註說明
  f910_15: string; // 上班組別代號
  f910_16: string; // 輪休組別代號
  f910_17: string; // 請假單號
  f910_19: string; // 出差單號
  f910_20: string; // 調班單號
  f910_21: string; // 刷卡上班時間
  f910_22: string; // 刷卡下班時間
  f910_23: string; // 加班刷卡開始時間
  f910_24: string; // 加班刷卡結束時間
  f910_29: number; // 遲到分鐘數
  f910_30: number; // 早退分鐘數
  f910_31: string; // 部門代號
  f910_32: string; // 應上班時間
  f910_33: string; // 應下班時間
}

export interface UpdateRequest {
  f910_11: string;
  f910_13: string;
  f910_14: string;
  f910_15: string;
  f910_16: string;
  f910_17: string;
  f910_19: string;
  f910_20: string;
  f910_21: string;
  f910_22: string;
  f910_23: string;
  f910_24: string;
  f910_29: number;
  f910_30: number;
  f910_31: string;
  f910_32: string;
  f910_33: string;
}

export interface ListResponse {
  data: F910[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

/** Build composite ID for the URL: empID_YYYY-MM-DD */
function compositeId(empId: string, date: string): string {
  // date may be ISO datetime, extract YYYY-MM-DD
  const d = date ? date.substring(0, 10) : '';
  return `${encodeURIComponent(empId)}_${d}`;
}

export const pw9210f1Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pw9210f1', { params });
    return res.data;
  },

  async searchByDateRange(startDate: string, endDate: string, empId?: string, page = 1, size = 100): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size, start_date: startDate, end_date: endDate };
    if (empId) params.emp_id = empId;
    const res = await apiClient.get('/api/pw9210f1', { params });
    return res.data;
  },

  async get(empId: string, date: string): Promise<F910> {
    const res = await apiClient.get(`/api/pw9210f1/${compositeId(empId, date)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F910> {
    const res = await apiClient.post('/api/pw9210f1', data);
    return res.data;
  },

  async update(empId: string, date: string, data: UpdateRequest): Promise<F910> {
    const res = await apiClient.put(`/api/pw9210f1/${compositeId(empId, date)}`, data);
    return res.data;
  },

  async delete(empId: string, date: string): Promise<void> {
    await apiClient.delete(`/api/pw9210f1/${compositeId(empId, date)}`);
  },
};
